import { toDateTime } from './date/format';

const verifiedByMessageGetter = (verified, lowercaseInitialLetter = false) =>
  `${lowercaseInitialLetter ? 'v' : 'V'}erified by ${verified.verifier} at ${toDateTime(verified.dateTime)}`;

export default verifiedByMessageGetter;